import api from '@/config/api'
import store from 'store'
import vuex from '@/store'
import dayjs from 'dayjs'

export default {
  searchArchiveDate(date) {
    if (!date) return []
    const station = vuex.getters.currentStation.station
    let params = {
      'air_date>': dayjs(date).tz(vuex.getters.currentTimezone).startOf('day').toISOString(),
      'air_date<': dayjs(date).tz(vuex.getters.currentTimezone).endOf('day').toISOString(),
      limit: 8000,
      station
    }
    return api.get(`/v2/newsdesk/archive_rundowns`, { params })
  },
  searchArchiveAssignment(assignment_id, station) {
    if (!assignment_id) return []
    station = station ?? vuex.getters.currentStation.station
    let params = {
      assignment_id,
      limit: 20,
      station
    }
    return api.get(`/v2/newsdesk/archive_rundowns`, { params })
  }
}
